<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="医院名称" prop="hospitalName">
                <a-input v-model="queryParam.hospitalName" placeholder="请输入医院名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="省份" prop="provinceId">
                <a-select
                  v-model="queryParam.provinceId"
                  placeholder="请选择省份"
                  allow-clear
                  @change="handleProvinceChange"
                >
                  <a-select-option v-for="item in provinceList" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="城市" prop="cityId">
                <a-select
                  v-model="queryParam.cityId"
                  placeholder="请先选择省份"
                  allow-clear
                  :disabled="!queryParam.provinceId"
                >
                  <a-select-option v-for="item in cityList" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否百强" prop="isTop100">
                <a-select v-model="queryParam.isTop100" placeholder="请选择是否百强医院" allow-clear>
                  <a-select-option v-for="dict in dict.type.number_yes_no" :key="dict.value" :value="dict.value">
                    {{ dict.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="医院等级" prop="level">
                <a-select v-model="queryParam.level" placeholder="请选择医院等级" allow-clear>
                  <a-select-option v-for="dict in dict.type.hospital_level" :key="dict.value" :value="dict.value">
                    {{ dict.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="医院性质" prop="nature">
                <a-select v-model="queryParam.nature" placeholder="请选择医院性质" allow-clear>
                  <a-select-option v-for="dict in dict.type.hospital_nature" :key="dict.value" :value="dict.value">
                    {{ dict.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="医院类型" prop="type">
                <a-select v-model="queryParam.type" placeholder="请选择医院类型" allow-clear>
                  <a-select-option v-for="dict in dict.type.hospital_type" :key="dict.value" :value="dict.value">
                    {{ dict.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作栏 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['hospital:hospital:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['hospital:hospital:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['hospital:hospital:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleImport" v-hasPermi="['hospital:hospital:import']">
          <a-icon type="upload" />导入
        </a-button>
        <!-- 同步华歧系数按钮：新增选中数量提示 -->
        <a-button type="primary" @click="handleSyncScore" v-hasPermi="['hospital:hospital:syncScore']">
          <a-icon type="sync" />同步华歧系数
          <span v-if="selectedRowKeys.length > 0" class="selected-count">({{ selectedRowKeys.length }}条)</span>
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <a-modal
        title="导入"
        :visible="openUpload"
        :maskClosable="false"
        :confirm-loading="uploading"
        @cancel="importExcelHandleCancel"
        @ok="importExcelHandleChange"
      >
        <a-spin tip="上传中..." :spinning="uploading">
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :file-list="fileList"
            :multiple="false"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">请将文件拖拽到此处上传❥(^_-)</p>
            <p class="ant-upload-hint">支持单个上传，也可以点击后选择文件上传</p>
          </a-upload-dragger>
          <a @click="importTemplate">下载模板</a>
        </a-spin>
      </a-modal>

      <!-- 百强医院名次设置弹窗 -->
      <a-modal
        title="设置百强医院名次"
        :visible="top100ModalVisible"
        :maskClosable="false"
        :confirm-loading="top100Loading"
        @cancel="handleTop100ModalCancel"
        @ok="handleTop100ModalOk"
        width="400px"
      >
        <a-form :form="top100Form" layout="vertical">
          <a-form-item label="医院名称">
            <span>{{ currentTop100Hospital?.hospitalName || '' }}</span>
          </a-form-item>
          <a-form-item
            label="百强名次"
            :validateStatus="rankValidateStatus"
            :help="rankValidateHelp"
            required
          >
            <a-input-number
              v-model="top100Rank"
              :min="1"
              :max="100"
              :step="1"
              placeholder="请输入1-100之间的名次"
              style="width: 100%"
              @change="handleRankInputChange"
            />
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 同步华歧系数确认弹窗 -->
      <a-modal
        title="同步华歧系数"
        :visible="syncScoreModalVisible"
        :maskClosable="false"
        :confirm-loading="syncScoreLoading"
        @cancel="handleSyncScoreCancel"
        @ok="handleSyncScoreConfirm"
        width="400px"
      >
        <div style="padding: 20px 0; line-height: 1.6;">
          <!-- 适配选中/全部场景的文案 -->
          <p v-if="selectedRowKeys.length > 0">
            确认要同步选中的 {{ selectedRowKeys.length }} 家医院的华歧系数吗？
          </p>
          <p v-else>
            确认要同步所有医院的华歧系数吗？
          </p>
          <p style="color: #faad14; margin-top: 8px;">
            <a-icon type="exclamation-circle" />
            <span v-if="selectedRowKeys.length > 0">
              此操作将从外部数据源同步选中医院的最新华歧系数，覆盖现有数据（注：未选择数据将同步全部数据）
            </span>
            <span v-else>
              此操作将从外部数据源同步所有医院的最新华歧系数，覆盖现有数据（注：未选择数据将同步全部数据）
            </span>
          </p>
        </div>
      </a-modal>

      <!-- 加减分弹窗 -->
      <a-modal
        title="调整华歧系数"
        :visible="scoreModalVisible"
        :maskClosable="false"
        :confirm-loading="scoreLoading"
        @cancel="handleScoreModalCancel"
        @ok="handleScoreModalOk"
        width="400px"
      >
        <a-form :form="scoreForm" layout="vertical">
          <a-form-item label="医院名称">
            <span>{{ currentScoreHospital?.hospitalName || '' }}</span>
          </a-form-item>
          <a-form-item label="当前分值">
            <span>{{ currentScoreHospital?.score || 0 }}</span>
          </a-form-item>
          <a-form-item
            label="调整分值"
            :validateStatus="scoreValidateStatus"
            :help="scoreValidateHelp"
          >
            <a-input-number
              v-model="changeScore"
              :min="-3000"
              :max="3000"
              :step="1"
              placeholder="请输入调整分值"
              style="width: 100%"
              @change="handleScoreInputChange"
            />
          </a-form-item>
          <a-form-item label="调整后分值">
            <span :style="{ color: (currentScoreHospital?.score || 0) + (changeScore || 0) < 0 ? 'red' : 'inherit' }">
              {{ (currentScoreHospital?.score || 0) + (changeScore || 0) }}
            </span>
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 医院华歧系数详情抽屉 -->
      <a-drawer
        title="华歧系数详情"
        placement="right"
        :width="700"
        :visible="scoreDetailVisible"
        :closable="true"
        @close="handleScoreDetailClose"
        destroyOnClose="true"
      >
        <div v-if="currentScoreDetail" class="score-detail-container">
          <!-- 分模块展示，提升可读性 -->
          <div class="detail-section">
            <h4 class="section-title">基础信息分值</h4>
            <a-descriptions :column="2" bordered size="middle">
              <a-descriptions-item label="医院简介分值">
                {{ formatDecimal(currentScoreDetail.hospitalContent) }}
              </a-descriptions-item>
              <a-descriptions-item label="医院图片分值">
                {{ formatDecimal(currentScoreDetail.hospitalLogo) }}
              </a-descriptions-item>
              <a-descriptions-item label="有科室分值">
                {{ formatDecimal(currentScoreDetail.haveDepart) }}
              </a-descriptions-item>
              <a-descriptions-item label="每个科室介绍分值">
                {{ formatDecimal(currentScoreDetail.eachDepartContent) }}
              </a-descriptions-item>
              <a-descriptions-item label="科室图片分值">
                {{ formatDecimal(currentScoreDetail.eachDepartLogo) }}
              </a-descriptions-item>
              <a-descriptions-item label="医师简介分值">
                {{ formatDecimal(currentScoreDetail.eachDoctorContent) }}
              </a-descriptions-item>
            </a-descriptions>
          </div>

          <div class="detail-section" style="margin-top: 16px;">
            <h4 class="section-title">注册会员分值</h4>
            <a-descriptions :column="3" bordered size="middle">
              <a-descriptions-item label="三级医院注册分值">
                {{ formatDecimal(currentScoreDetail.levelThreeRegister) }}
              </a-descriptions-item>
              <a-descriptions-item label="二级医院注册分值">
                {{ formatDecimal(currentScoreDetail.levelTwoRegister) }}
              </a-descriptions-item>
              <a-descriptions-item label="一级医院注册分值">
                {{ formatDecimal(currentScoreDetail.levelOneRegister) }}
              </a-descriptions-item>
            </a-descriptions>
          </div>

          <div class="detail-section" style="margin-top: 16px;">
            <h4 class="section-title">医院等级分值</h4>
            <a-descriptions :column="3" bordered size="middle">
              <a-descriptions-item label="三级医院分值">
                {{ formatDecimal(currentScoreDetail.levelThreeHospital) }}
              </a-descriptions-item>
              <a-descriptions-item label="二级医院分值">
                {{ formatDecimal(currentScoreDetail.levelTwoHospital) }}
              </a-descriptions-item>
              <a-descriptions-item label="一级医院分值">
                {{ formatDecimal(currentScoreDetail.levelOneHospital) }}
              </a-descriptions-item>
            </a-descriptions>
          </div>

          <div class="detail-section" style="margin-top: 16px;">
            <h4 class="section-title">专科医院分值</h4>
            <a-descriptions :column="3" bordered size="middle">
              <a-descriptions-item label="三级专科医院分值">
                {{ formatDecimal(currentScoreDetail.specializedLevelThree) }}
              </a-descriptions-item>
              <a-descriptions-item label="二级专科医院分值">
                {{ formatDecimal(currentScoreDetail.specializedLevelTwo) }}
              </a-descriptions-item>
              <a-descriptions-item label="一级专科医院分值">
                {{ formatDecimal(currentScoreDetail.specializedLevelOne) }}
              </a-descriptions-item>
            </a-descriptions>
          </div>

          <div class="detail-section" style="margin-top: 16px;">
            <h4 class="section-title">百强医院名次分值</h4>
            <a-descriptions :column="2" bordered size="middle">
              <a-descriptions-item label="1-10名分值">
                {{ formatDecimal(currentScoreDetail.oneToTen) }}
              </a-descriptions-item>
              <a-descriptions-item label="11-20名分值">
                {{ formatDecimal(currentScoreDetail.elevenToTwenty) }}
              </a-descriptions-item>
              <a-descriptions-item label="21-30名分值">
                {{ formatDecimal(currentScoreDetail.twentyOneToThirty) }}
              </a-descriptions-item>
              <a-descriptions-item label="31-50名分值">
                {{ formatDecimal(currentScoreDetail.thirtyOneToFifty) }}
              </a-descriptions-item>
              <a-descriptions-item label="国内名医数量分值">
                {{ formatDecimal(currentScoreDetail.nationalFamousDoctorCount) }}
              </a-descriptions-item>
              <a-descriptions-item label="省内名医数量分值">
                {{ formatDecimal(currentScoreDetail.provincialFamousDoctorCount) }}
              </a-descriptions-item>
              <a-descriptions-item label="特色加减分">
                {{ formatDecimal(currentScoreDetail.addScore) }}
              </a-descriptions-item>
            </a-descriptions>
          </div>

          <!-- 总分展示（自动计算） -->
          <div class="detail-section" style="margin-top: 24px;">
            <a-descriptions :column="1" bordered size="middle">
              <a-descriptions-item label="华歧系数总分">
                <span style="font-size: 18px; font-weight: bold; color: #1890ff;">
                  {{ calculateTotalScore() }}
                </span>
              </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>
        <div v-else class="empty-tip">
          <a-empty description="暂无华歧系数数据" />
        </div>
      </a-drawer>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1800 }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="logo" slot-scope="text, record">
          <img v-viewer v-if="record.logo" :src="processImageUrl(record.logo)" style="width: 50px; height: 50px;">
        </span>
        <!-- 医院等级字典渲染 -->
        <span slot="level" slot-scope="text, record">
          <dict-tag :options="dict.type['hospital_level']" :value="record.level"/>
        </span>
        <span slot="type" slot-scope="text, record">
          <dict-tag :options="dict.type['hospital_type']" :value="record.type"/>
        </span>
        <span slot="nature" slot-scope="text, record">
          <dict-tag :options="dict.type['hospital_nature']" :value="record.nature"/>
        </span>
        <span slot="honor" slot-scope="text, record">
          <a-tag v-if="record.isTop100 === 1" color="gold">百强医院</a-tag>
          <a-tag v-for="(honor, index) in getCustomHonors(record.honor)" :key="index" color="blue">
            {{ honor }}
          </a-tag>
          <span v-if="!record.isTop100 && !getCustomHonors(record.honor).length">-</span>
        </span>
        <span slot="certificate" slot-scope="text, record">
          <a v-if="record.certificate" @click="viewCertificates(record)">
            <a-icon type="picture" /> 查看
          </a>
          <span v-else>-</span>
        </span>
        <!-- 百强医院开关列 -->
        <span slot="isTop100" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmHandleIsTop100(record)"
            @cancel="cancelHandleIsTop100(record)"
          >
            <span slot="title">确认{{ record.isTop100 === 1 ? '取消' : '设置' }}{{ record.hospitalName }}为百强医院吗?</span>
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="record.isTop100 === 1"
              v-hasPermi="['hospital:hospital:top100']"
            />
          </a-popconfirm>
        </span>
        <!-- 百强名次展示列 -->
        <span slot="top100Rank" slot-scope="text, record">
          {{ record.isTop100 === 1 ? (record.top100Rank || '未设置') : '非百强' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['hospital:hospital:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['hospital:hospital:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['hospital:hospital:remove']">
            <a-icon type="delete" />删除
          </a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" href="#">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['hospital:hospital:top100']">
                <a @click="handleSetTop100Rank(record)" :disabled="!record.isTop100">
                  <a-icon type="trophy" />设置名次
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['hospital:hospital:scoreDetail']">
                <a @click="handleScoreDetail(record)">
                  <a-icon type="file-text" />华歧系数详情
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['hospital:hospital:score']">
                <a @click="handleScoreAdjust(record)">
                  <a-icon type="calculator" />加减分
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 荣誉证书预览modal -->
    <a-modal
      v-model="certificatePreviewVisible"
      title="荣誉证书预览"
      :footer="null"
      :width="800"
      centered
    >
      <div style="text-align: center;">
        <img
          :src="certificateImages[currentPreviewIndex]"
          style="max-width: 100%; max-height: 600px;"
          alt="荣誉证书"
        />
        <div v-if="certificateImages.length > 1" style="margin-top: 16px;">
          <a-button @click="prevImage" :disabled="currentPreviewIndex === 0">
            上一张
          </a-button>
          <span style="margin: 0 16px;">
            {{ currentPreviewIndex + 1 }} / {{ certificateImages.length }}
          </span>
          <a-button @click="nextImage" :disabled="currentPreviewIndex === certificateImages.length - 1">
            下一张
          </a-button>
        </div>
      </div>
    </a-modal>


  </page-header-wrapper>
</template>

<script>
import {
  pageHospital,
  listHospital,
  delHospital,
  importHospital,
  changeHospitalTop100Status,
  syncHospitalScore,
  getHospitalScoreDetail, // 新增：获取医院华歧系数详情接口
  adjustHospitalScore // 新增：医院加减分接口
} from '@/api/hospital/hospital'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { processImageUrl } from '@/utils/util'
import { getProvinceList, getCityListByProvinceId } from '@/api/system/area'
import moment from 'moment'

export default {
  name: 'Hospital',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['hospital_level', 'hospital_type', 'hospital_nature', 'number_yes_no'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      fileList: [],
      // 非单个禁用
      single: true,
      uploading: false,
      openUpload: false,

      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 省份城市相关
      provinceList: [],
      cityList: [],
      // 查询参数
      queryParam: {
        userId: null,
        hospitalAuthId: null,
        hospitalName: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        areaId: null,
        areaName: null,
        address: null,
        lon: null,
        lat: null,
        logo: null,
        level: null,
        type: null,
        nature: null,
        honor: null,
        content: null,
        certificate: null,
        score: null,
        isTop100: null, // 新增：是否百强医院筛选
        pageNum: 1,
        pageSize: 10
      },
      // 百强医院相关
      top100ModalVisible: false,
      top100Loading: false,
      top100Form: this.$form.createForm(this),
      currentTop100Hospital: null,
      top100Rank: 0,
      rankValidateStatus: 'success',
      rankValidateHelp: '请输入1-100之间的名次',
      // 新增：同步华歧系数相关
      syncScoreModalVisible: false,
      syncScoreLoading: false,
      // 新增：华歧系数详情相关
      scoreDetailVisible: false,
      currentScoreDetail: null,
      // 新增：加减分相关
      scoreModalVisible: false,
      scoreLoading: false,
      scoreForm: this.$form.createForm(this),
      currentScoreHospital: null,
      changeScore: 0,
      scoreValidateStatus: 'success',
      scoreValidateHelp: '正数为加分，负数为减分，0为不调整',
      // 新增：荣誉证书预览相关
      certificatePreviewVisible: false,
      certificateImages: [],
      currentPreviewIndex: 0,
      columns: [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '医院地址',
        //   dataIndex: 'address',
        //   width: 250,
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '医院标志',
        //   dataIndex: 'logo',
        //   width: 120,
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'logo' },
        //   align: 'center'
        // },
        {
          title: '医院等级',
          dataIndex: 'level',
          width: 100,
          scopedSlots: { customRender: 'level' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '医院类型',
          dataIndex: 'type',
          width: 100,
          scopedSlots: { customRender: 'type' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '医院性质',
          dataIndex: 'nature',
          width: 100,
          scopedSlots: { customRender: 'nature' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '获得荣誉',
        //   dataIndex: 'honor',
        //   width: 150,
        //   scopedSlots: { customRender: 'honor' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '荣誉证书',
        //   dataIndex: 'certificate',
        //   width: 100,
        //   scopedSlots: { customRender: 'certificate' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '华歧系数',
          dataIndex: 'score',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否百强医院',
          dataIndex: 'isTop100',
          width: 120,
          scopedSlots: { customRender: 'isTop100' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '百强名次',
          dataIndex: 'top100Rank',
          width: 100,
          scopedSlots: { customRender: 'top100Rank' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160,
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
    this.loadProvinceList()
  },
  computed: {},
  watch: {
    'queryParam.provinceId': {
      handler(newVal) {
        if (newVal) {
          this.loadCityList(newVal)
        } else {
          this.cityList = []
          this.queryParam.cityId = undefined
        }
      }
    }
  },
  methods: {
    processImageUrl,

    // 加载省份列表
    loadProvinceList() {
      getProvinceList().then(res => {
        console.log('省份列表响应:', res)
        if (res.code === '20001' && res.data) {
          this.provinceList = res.data.map(item => ({
            id: item.areaId,
            name: item.areaName
          }))
          console.log('省份列表数据:', this.provinceList)
        } else {
          console.error('省份列表加载失败:', res)
        }
      }).catch(err => {
        console.error('省份列表请求异常:', err)
      })
    },

    // 加载城市列表
    loadCityList(provinceId) {
      getCityListByProvinceId(provinceId).then(res => {
        console.log('城市列表响应:', res)
        if (res.code === '20001' && res.data) {
          this.cityList = res.data.map(item => ({
            id: item.areaId,
            name: item.areaName
          }))
          console.log('城市列表数据:', this.cityList)
        } else {
          console.error('城市列表加载失败:', res)
          this.cityList = []
        }
      }).catch(err => {
        console.error('城市列表请求异常:', err)
        this.cityList = []
      })
    },

    // 省份变更处理
    handleProvinceChange(value) {
      this.queryParam.cityId = undefined
      if (value) {
        this.loadCityList(value)
      } else {
        this.cityList = []
      }
    },

    // 城市变更处理
    handleCityChange(value) {
      // 城市变更逻辑
    },
    /** 查询医院信息列表 */
    getList() {
      this.loading = true
      pageHospital(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    beforeUpload(file) {
      this.fileList = [file]
      return false
    },

    importTemplate() {
      this.download(
        "hospital/hospital/importTemplate",
        {},
        `hospital_${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );
    },

    importExcelHandleChange() {
      this.uploading = true
      const { fileList } = this
      const formData = new FormData()
      formData.append('file', fileList[0])
      importHospital(formData)
        .then((response) => {
          if (response.success) {
            this.fileList = []
            this.$message.success(response.message)
            this.openUpload = false
            this.$emit('ok', response.data)
            this.getList()
          } else {
            this.$message.error(response.message)
            return
          }
        })
        .finally(() => {
          this.uploading = false
        })
    },

    handleImport() {
      this.title = "导入";
      this.openUpload = true;
    },

    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
    importExcelHandleCancel(e) {
      this.openUpload = false
      this.fileList = []
      // 关闭后刷新列表
      this.$emit('ok')
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 - 新增isTop100重置 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        hospitalAuthId: undefined,
        hospitalName: undefined,
        provinceId: undefined,
        provinceName: undefined,
        cityId: undefined,
        cityName: undefined,
        areaId: undefined,
        areaName: undefined,
        address: undefined,
        lon: undefined,
        lat: undefined,
        logo: undefined,
        level: undefined,
        type: undefined,
        nature: undefined,
        honor: undefined,
        content: undefined,
        certificate: undefined,
        score: undefined,
        isTop100: undefined, // 新增：重置百强医院筛选条件
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({ "id": id }))
          return delHospital(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('hospital/hospital/export', {
            ...that.queryParam
          }, `医院信息_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    },

    // ========== 华歧系数详情方法 ==========
    /**
     * 格式化小数显示（空值显示0，保留2位小数）
     */
    formatDecimal(value) {
      if (value === null || value === undefined) {
        return '0.00'
      }
      return Number(value).toFixed(2)
    },

    /**
     * 计算医院华歧系数总分
     */
    calculateTotalScore() {
      if (!this.currentScoreDetail) return '0.00'

      const {
        // 基础信息分值
        hospitalContent, hospitalLogo, haveDepart,
        eachDepartContent, eachDepartLogo, eachDoctorContent,
        // 注册会员分值
        levelThreeRegister, levelTwoRegister, levelOneRegister,
        // 医院等级分值
        levelThreeHospital, levelTwoHospital, levelOneHospital,
        // 专科医院分值
        specializedLevelThree, specializedLevelTwo, specializedLevelOne,
        // 百强名次分值
        oneToTen, elevenToTwenty, twentyOneToThirty, thirtyOneToFifty,
        // 名医数量
        nationalFamousDoctorCount, provincialFamousDoctorCount,
        // 特色加减分
        addScore
      } = this.currentScoreDetail

      // 累加所有分值字段
      const total = [
        hospitalContent, hospitalLogo, haveDepart,
        eachDepartContent, eachDepartLogo, eachDoctorContent,
        levelThreeRegister, levelTwoRegister, levelOneRegister,
        levelThreeHospital, levelTwoHospital, levelOneHospital,
        specializedLevelThree, specializedLevelTwo, specializedLevelOne,
        oneToTen, elevenToTwenty, twentyOneToThirty, thirtyOneToFifty,
        nationalFamousDoctorCount, provincialFamousDoctorCount,
        addScore // 特色加减分
      ].reduce((sum, val) => sum + (Number(val) || 0), 0)

      return total.toFixed(2)
    },

    // ========== 百强医院相关方法 ==========
    /**
     * 确认设置/取消百强医院
     */
    confirmHandleIsTop100(record) {
      const oldStatus = record.isTop100
      const newStatus = record.isTop100 === 1 ? 0 : 1
      const text = newStatus === 1 ? '设置' : '取消'

      // 调用百强医院状态修改接口
      changeHospitalTop100Status(record.id, newStatus)
        .then((res) => {
          if (res.success) {
            this.$message.success(`${text}百强医院成功`, 3)
            // 刷新整个列表，确保数据与后端同步
            this.getList()

            // 如果是设置为百强且暂无名次，自动弹出名次设置弹窗
            if (newStatus === 1) {
              // 延迟执行，确保列表已刷新完成
              setTimeout(() => {
                const updatedRecord = this.list.find(item => item.id === record.id)
                if (updatedRecord && !updatedRecord.top100Rank) {
                  this.handleSetTop100Rank(updatedRecord)
                }
              }, 300)
            }
          } else {
            this.$message.error(`${text}百强医院失败: ${res.message}`, 3)
          }
        }).catch(() => {
        this.$message.error(`${text}百强医院异常`, 3)
      })
    },

    /**
     * 取消设置百强医院（空方法，仅用于弹窗取消）
     */
    cancelHandleIsTop100(record) {
      // 取消操作，无需处理
    },

    /**
     * 打开百强名次设置弹窗
     */
    handleSetTop100Rank(record) {
      // 重置表单状态
      this.top100Rank = record.top100Rank || 1
      this.rankValidateStatus = 'success'
      this.rankValidateHelp = '请输入1-100之间的名次'
      this.currentTop100Hospital = { ...record }
      this.top100ModalVisible = true
    },

    /**
     * 关闭百强名次设置弹窗
     */
    handleTop100ModalCancel() {
      this.top100ModalVisible = false
      this.currentTop100Hospital = null
      this.top100Rank = 0
      this.rankValidateStatus = 'success'
      this.rankValidateHelp = '请输入1-100之间的名次'
    },

    /**
     * 名次输入变化校验
     */
    handleRankInputChange() {
      this.validateRank()
    },

    /**
     * 名次校验逻辑
     */
    validateRank() {
      if (!this.top100Rank || this.top100Rank < 1 || this.top100Rank > 100) {
        this.rankValidateStatus = 'error'
        this.rankValidateHelp = '请输入1-100之间的有效名次'
        return false
      } else {
        this.rankValidateStatus = 'success'
        this.rankValidateHelp = '请输入1-100之间的名次'
        return true
      }
    },

    /**
     * 确认设置百强名次
     */
    handleTop100ModalOk() {
      const isValid = this.validateRank()

      if (!isValid) {
        this.$message.error('请输入1-100之间的有效名次')
        return
      }

      this.top100Loading = true

      // 调用设置百强名次接口
      changeHospitalTop100Status(this.currentTop100Hospital.id, 1, this.top100Rank)
        .then((res) => {
          if (res.success) {
            this.$message.success('百强名次设置成功')
            this.top100ModalVisible = false
            // 刷新列表，确保名次更新生效
            this.getList()
            this.top100Rank = 0
          } else {
            this.$message.error(`百强名次设置失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('百强名次设置异常，请稍后重试')
        })
        .finally(() => {
          this.top100Loading = false
        })
    },

    // ========== 同步华歧系数相关方法 ==========
    /**
     * 打开同步华歧系数确认弹窗
     */
    handleSyncScore() {
      this.syncScoreModalVisible = true
    },

    /**
     * 取消同步华歧系数（关闭弹窗）
     */
    handleSyncScoreCancel() {
      this.syncScoreModalVisible = false
      this.syncScoreLoading = false
    },

    /**
     * 确认同步华歧系数
     * - 无选中ID → 传空数组，同步全部医院
     * - 有选中ID → 传[{"id":xxx}]格式，同步指定医院
     */
    handleSyncScoreConfirm() {
      this.syncScoreLoading = true

      // 构建参数
      let syncParams = []
      if (this.selectedRowKeys.length > 0) {
        syncParams = this.selectedRowKeys.map(id => ({ id: id }))
      }

      // 调用同步华歧系数接口（传递数组参数）
      syncHospitalScore(syncParams)
        .then((res) => {
          if (res.success) {
            // 适配选中/全部场景的提示文案
            if (this.selectedRowKeys.length > 0) {
              this.$message.success(`已成功同步选中的 ${this.selectedRowKeys.length} 家医院华歧系数`)
            } else {
              this.$message.success('已成功同步所有医院华歧系数')
            }
            this.syncScoreModalVisible = false
            // 刷新列表，展示最新的华歧系数
            this.getList()
          } else {
            this.$message.error(`医院华歧系数同步失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('医院华歧系数同步异常，请稍后重试')
        })
        .finally(() => {
          this.syncScoreLoading = false
        })
    },

    // ========== 医院华歧系数详情相关方法 ==========
    /**
     * 打开医院华歧系数详情抽屉
     */
    handleScoreDetail(record) {
      this.scoreDetailVisible = true
      // 调用接口获取医院华歧系数详情
      getHospitalScoreDetail(record.id)
        .then((res) => {
          if (res.success) {
            this.currentScoreDetail = res.data
          } else {
            this.currentScoreDetail = null
            this.$message.error(`获取华歧系数详情失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.currentScoreDetail = null
          this.$message.error('获取华歧系数详情异常，请稍后重试')
        })
    },
    /**
     * 关闭医院华歧系数详情抽屉
     */
    handleScoreDetailClose() {
      this.scoreDetailVisible = false
      this.currentScoreDetail = null
    },
    // ========== 加减分相关方法 ==========
    /**
     * 打开加减分弹窗
     */
    handleScoreAdjust(record) {
      this.scoreModalVisible = true
      this.changeScore = 0
      this.scoreValidateStatus = 'success'
      this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
      this.currentScoreHospital = { ...record }
    },
    /**
     * 关闭加减分弹窗
     */
    handleScoreModalCancel() {
      this.scoreModalVisible = false
      this.currentScoreHospital = null
      this.changeScore = 0
      this.scoreValidateStatus = 'success'
      this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
    },
    /**
     * 输入分值变化校验
     */
    handleScoreInputChange() {
      this.validateScore()
    },
    /**
     * 分值校验
     */
    validateScore() {
      if (!this.changeScore || this.changeScore === 0) {
        this.scoreValidateStatus = 'error'
        this.scoreValidateHelp = '请输入非零的调整分值'
        return false
      }
      const currentScore = this.currentScoreHospital?.score || 0
      const afterScore = currentScore + (this.changeScore || 0)
      if (afterScore < 0) {
        this.scoreValidateStatus = 'error'
        this.scoreValidateHelp = '减分值不能超过当前总分'
        return false
      }
      this.scoreValidateStatus = 'success'
      this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
      return true
    },
    /**
     * 确认加减分
     */
    handleScoreModalOk() {
      const isValid = this.validateScore()
      if (!isValid) {
        this.$message.error('请检查输入的分值')
        return
      }

      this.scoreLoading = true
      adjustHospitalScore(this.currentScoreHospital.id, this.changeScore)
        .then((res) => {
          if (res.success) {
            this.$message.success('分值调整成功')
            this.scoreModalVisible = false
            this.getList()
            this.changeScore = 0
          } else {
            this.$message.error(`分值调整失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('分值调整异常，请稍后重试')
        })
        .finally(() => {
          this.scoreLoading = false
        })
    },
    // 获取自定义荣誉列表
    getCustomHonors(honorStr) {
      if (!honorStr) return []
      // 从逗号分隔的字符串中解析荣誉
      const honorList = honorStr.split(',').map(item => item.trim())
      // 过滤掉"百强医院"
      return honorList.filter(item => item && item !== '百强医院')
    },
    // 查看荣誉证书
    viewCertificates(record) {
      if (record.certificate) {
        this.certificateImages = record.certificate.split(',').map(url => processImageUrl(url))
        this.currentPreviewIndex = 0
        this.certificatePreviewVisible = true
      } else {
        this.$message.warning('暂无荣誉证书')
      }
    },
    // 上一张图片
    prevImage() {
      if (this.currentPreviewIndex > 0) {
        this.currentPreviewIndex--
      }
    },
    // 下一张图片
    nextImage() {
      if (this.currentPreviewIndex < this.certificateImages.length - 1) {
        this.currentPreviewIndex++
      }
    }
  }
}
</script>

<style scoped>
/* 原有样式 */
.ant-table-cell .ant-divider {
  margin: 0 4px;
}
/* 选中数量提示样式 */
.selected-count {
  display: inline-block;
  background: #1890ff;
  color: white;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 8px;
  margin-left: 4px;
}

/* 华歧系数详情样式 */
.score-detail-container {
  padding: 16px 0;
}

.detail-section {
  margin-bottom: 8px;
}

.section-title {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  border-left: 3px solid #1890ff;
  padding-left: 8px;
}

.empty-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
}

.ant-descriptions-item-content {
  word-break: break-all;
}
</style>